/**
 * @description 教书先生API - https://api.oioweb.cn/
 * @created 2024/04/28 10:46:22
 */
import request from "@/utils/request"
const KEY = "/api-oioweb"

import proxy from "@/configs/proxy"
import { IS_DEV } from "@/constants/is"
const BASE_URL = IS_DEV ? KEY : proxy[KEY].target

/**
 * @description 解析二维码内容
 * @created 2024/04/28 10:49:16
 * @see https://api.oioweb.cn/doc/qrcode/decode
 * @param {File} file 二维码文件对象
 */
export function decodeQRcode(file) {
  const data = new FormData()
  data.append("file", file)
  return request({
    baseURL: BASE_URL,
    url: "/qrcode/decode",
    method: "POST",
    data
  })
}
